export default "__VITE_ASSET__D7lURJ5R__"